<template>
  <div class="container">
    <div class="inline-wrapper wrapper-head">
      <div class="date-left">
        <el-form
          inline
          size="mini"
          label-width="66px"
          label-position="left"
          class="table-search-part"
          @submit.native.prevent="handleQuery()"
        >
          <el-form-item label="Match ID" class="match-input">
            <el-input v-model="queryData.matchId" clearable type="number" placeholder="Match ID"></el-input>
          </el-form-item>
          <el-form-item label="Event Time">
            <el-date-picker
              v-model="date"
              clearable
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              @change="orderDate"
              type="datetimerange"
              range-separator="-"
              start-placeholder="Start Time"
              end-placeholder="End Time"
            ></el-date-picker>
          </el-form-item>
          <el-button
            class="search-btn"
            :disabled="!queryData.matchId"
            type="primary"
            style="margin-left: 10px;"
            @click="handleQuery()"
          >Search</el-button>
          <el-button
            class="clear-btn"
            :disabled="!queryData.matchId"
            @click="handleClearQuery()"
          >Clear</el-button>
        </el-form>
      </div>
      <div class="middle-btn inline-right date-right">
        <div class="art-box">
          <p>
            <span class="color-box" style="background: #DE0A00;"></span>
            <span class="names">Goals</span>
          </p>
          <p>
            <span class="color-box" style="background: #D97975;"></span>
            <span class="names">Red card</span>
          </p>
          <p>
            <span class="color-box" style="background: #C1A200;"></span>
            <span class="names">Yellow card</span>
          </p>
          <p>
            <span class="color-box" style="background: #00A791;"></span>
            <span class="names">Corner</span>
          </p>
        </div>
        <el-button class="lebel-risk-export-btn" id="download" @click="handleExport()">
          <i class="icon iconfont iconProperty1xiazai"></i> Export
        </el-button>
      </div>
    </div>
    <div>
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        v-loading="loading"
        :row-class-name="tableRowName"
        header-row-class-name="table-header-row"
        border
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="Event Time">
          <template v-slot="{row}">
            <div v-if="row.date">{{ formatUtc(row.date) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Match Running Time">
          <template v-slot="{row}">
            <div
              v-if="row.date"
            >{{formatMatchPeriod(row.matchPeriod)}} {{ formatUtcMS(row.timing) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="Event name" prop="eventName"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Empty from "@/components/empty/index";

import { getEventList, getEventExport } from "@/api/event";
const GOALS = [
  1033,
  1035,
  1037,
  1069,
  1071,
  1094,
  1095,
  1096,
  1109,
  1117,
  1118,
  1119,
  1121,
  1142,
  1143,
  1157,
  1166,
  1167,
  1169,
  1198,
  1199,
  1216,
  1217,
  1223,
  1224
];
const RED_CARD = [
  1034,
  1097,
  1105,
  1106,
  1107,
  1125,
  1126,
  1145,
  1153,
  1154,
  1155,
  1173,
  1174,
  1200,
  1201,
  1229,
  1230,
  1231,
  1232
];
const YELLOW_CARD = [
  1098,
  1108,
  1124,
  1146,
  1156,
  1172,
  1205,
  1206,
  1207,
  1221,
  1222,
  1227,
  1228
];
const CORNER = [
  1090,
  1110,
  1122,
  1123,
  1138,
  1158,
  1170,
  1171,
  1218,
  1219,
  1220,
  1225,
  1226,
  1233
];
const MATCH_PERIOD = {
  1001: "Not start",
  1002: "1H",
  1003: "HT",
  1004: "2H",
  1005: "FT",
  1006: "ET-1H",
  1007: "ET-HT",
  1008: "ET-2H",
  1009: "ET-FT",
  1010: "PEN",
  1011: "FIN",
  1012: "AWT ET",
  1013: "AWT PEN",
  1014: "PEN-FIN",
  1015: "INTRP",
  1016: "AB",
  3001: "Not start",
  3002: "1H",
  3003: "HT",
  3004: "2H",
  3005: "Q1",
  3006: "BRK1",
  3007: "Q2",
  3008: "HT",
  3009: "Q3",
  3010: "BRK3",
  3011: "Q4",
  3012: "OT",
  3013: "RT",
  3014: "FIN",
  3015: "AWT OT",
  3016: "OT-FIN",
  3017: "DL",
  3018: "INTRP",
  3019: "AB"
};
export default {
  name: "EventList",
  data() {
    return {
      list: [],
      loading: false,
      queryData: {
        matchId: "",
        startTime: "",
        endTime: "",
        current: 1,
        size: 50
      },
      total: 0,
      date: "",
      curDate: "",
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.curDate = minDate.getTime();
          if (maxDate) {
            this.curDate = "";
          }
        },
        disabledDate: time => {
          if (this.curDate) {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.curDate - one;
            const maxTime = this.curDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      tableHeight: window.innerHeight
    };
  },
  methods: {
    orderDate(val) {
      if (val != null) {
        const [startTime, endTime] = val;
        this.queryData.startTime = startTime;
        this.queryData.endTime = endTime;
      } else {
        this.queryData.startTime = "";
        this.queryData.endTime = "";
      }
    },
    async getList() {
      this.loading = true;
      try {
        const res = await getEventList(this.queryData);
        const data = res.data || [];
        this.list = data.records || [];
        this.total = data.total || 0;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    tableRowName({ row, rowIndex }) {
      if (GOALS.includes(row.eventCode)) {
        return "goals-row";
      } else if (RED_CARD.includes(row.eventCode)) {
        return "red-row";
      } else if (YELLOW_CARD.includes(row.eventCode)) {
        return "yellow-row";
      } else if (CORNER.includes(row.eventCode)) {
        return "corner-row";
      }
    },
    formatMatchPeriod(period) {
      return MATCH_PERIOD[period] || "";
    },
    // 清空
    handleClear() {
      this.queryData = {
        ...this.queryData,
        matchId: ""
      };
      this.date = "";
    },
    // 搜索
    handleQuery() {
      this.queryData.current = 1;
      this.getList();
    },
    // 清除搜索
    handleClearQuery() {
      this.handleClear();
      //this.getList();
    },
    // utc时间
    formatUtc(time) {
      if(!time) return "";
      return this.$moment(+time).format("YYYY-MM-DD HH:mm:ss");
    },
    formatUtcMS(time) {
      const totalSeconds = Math.floor(time / 1000); // 将毫秒转换为秒
      const minutes = Math.floor(totalSeconds / 60); // 计算总分钟数
      const seconds = totalSeconds % 60; // 计算剩余的秒数

      // 格式化分钟和秒数，确保在数字小于10时前面加上0
      const formattedMinutes = `${minutes}`;
      const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

      return `${formattedMinutes}:${formattedSeconds}`;
    },
    handleExport() {
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const param = { ...this.queryData, timeZone: timeZone };
      getEventExport(param, "export.xlsx");
    },
    // 分页
    changePage(e) {
      this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
      this.queryData.size = e;
      this.queryData.current = 1;
      this.getList();
    },
    // 去除空格
    formatContent(val) {
      return val.replace(/\s+/g, "");
    }
  },
  components: {
    Empty
  },
  mounted() {
    const { matchId, orderTime } = this.$route.query;
    if (matchId && orderTime) {
      this.date = [Number(orderTime), Number(orderTime) + 60000];
      this.queryData.matchId = matchId;
      this.queryData.startTime = Number(orderTime);
      this.queryData.endTime = Number(orderTime) + 60000;
      this.getList();
    }
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.wrapper-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .date-left {
    width: auto;
  }
  .inline-right {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: auto;
    .art-box {
      display: flex;
      align-items: center;
      p {
        display: flex;
        align-items: center;
        margin-right: 20px;
        .color-box {
          width: 14px;
          height: 14px;
        }
        .names {
          font-size: 12px;
          color: #333333;
          margin-left: 8px;
        }
      }
    }
  }
}
.middle-btn {
  margin: 18px 0;
}
.match-input {
  margin: 0 20px 0 0 !important;
}
/deep/.el-table .goals-row {
  color: #de0a00;
  td:first-child {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 32px;
      background: #de0a00;
    }
  }
}
/deep/.el-table .red-row {
  color: #d97975;
  td:first-child {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 32px;
      background: #d97975;
    }
  }
}
/deep/.el-table .yellow-row {
  color: #c1a200;
  td:first-child {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 32px;
      background: #c1a200;
    }
  }
}
/deep/.el-table .corner-row {
  color: #00a791;
  td:first-child {
    position: relative;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 4px;
      height: 32px;
      background: #00a791;
    }
  }
}
</style>
